module.exports = __webpack_public_path__ + "img/info-light.1ce2419f.png";